import { render, staticRenderFns } from "./CollectionViewCollection.vue?vue&type=template&id=40a0e334&scoped=true&"
import script from "./CollectionViewCollection.vue?vue&type=script&lang=js&"
export * from "./CollectionViewCollection.vue?vue&type=script&lang=js&"
import style0 from "./CollectionViewCollection.vue?vue&type=style&index=0&id=40a0e334&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a0e334",
  null
  
)

export default component.exports